import React from 'react';
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';

interface IProps {
  value: string;
  onChange: (v: string) => void;
}

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['link'],
  ],
};

const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link'];

export const Wysiwyg = ({ value, onChange }: IProps) => {
  const fmt = value?.replace(/<span style="text-decoration:underline;">/g, '<u>').replace(/<span style="text-decoration:line-through;">/g, '<s>');
  return <ReactQuill value={fmt} onChange={onChange} modules={modules} formats={formats} />;
};
